module.exports = __webpack_public_path__ + "static/media/YF65_1.72e061c2.jpg";